<template>
    <div class="px-2 py-2">
        <div class="h-full flex items-center p-4 bg-white rounded-lg shadow-xs dark:bg-gray-800 transition-colors duration-150">
            <div class="font-semibold w-12 h-12 flex items-center justify-center mr-4 rounded-full" :class="circleColorClasses">
                <slot name="circle"></slot>
            </div>
            <div class="flex-1">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import {computed} from "vue";

export default {
    name: "DashboardCard",
    props: {
        circleColor: {
            type: String,
            required: false,
        },
    },
    setup(props) {
        const circleColorClasses = computed(() => {
            switch (props.circleColor) {
                case 'dark-orange':
                    return 'text-orange-700 bg-orange-100 dark:text-white dark:bg-orange-600';
                case 'yellow':
                    return 'text-yellow-500 bg-yellow-100 dark:text-yellow-100 dark:bg-yellow-500';
                case 'orange':
                    return 'text-orange-500 bg-orange-100 dark:text-orange-100 dark:bg-orange-500';
                case 'blue':
                    return 'text-blue-500 bg-blue-100 dark:text-blue-100 dark:bg-blue-500';
                case 'red':
                    return 'text-red-500 bg-red-100 dark:text-red-100 dark:bg-red-500';
                case 'green':
                    return 'text-green-500 bg-green-100 dark:text-green-100 dark:bg-green-500';
                case 'teal':
                    return 'text-teal-500 bg-teal-100 dark:text-teal-100 dark:bg-teal-500';
                case 'indigo':
                    return 'text-indigo-500 bg-indigo-100 dark:text-indigo-100 dark:bg-indigo-500';
                default:
                    return 'text-gray-700 bg-gray-100 dark:text-gray-100 dark:bg-gray-700';
            }
        });

        return {
            circleColorClasses,
        };
    }
}
</script>

<style scoped>

</style>
